import { Avatar, Badge, Box, Button, ButtonGroup, Flex, Heading, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverFooter, PopoverHeader, PopoverTrigger, Spinner, Text, Textarea, useDisclosure, useToast } from '@chakra-ui/react'
import { AgentCardHolder, Container, ContentContainer, HeaderText, HoriLine, MainContainer, PentagonBg, SectionHeader } from './FindAnAgentStyles'
import pentagon from '../../public/images/pentagon.svg'
import { CheckCircleIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, CloseIcon, DeleteIcon, SearchIcon, SmallCloseIcon } from '@chakra-ui/icons'
import { propertyTypeOptions } from '../Listing/data'
import AgentCard from './AgentCard'
import { ListingsSpinnerHolder, PaginationButtonHolder } from '../../styles/ListingsStyles'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useMutation, useQuery } from 'react-query'
import { useLoadScript } from '@react-google-maps/api'
import NewFooter from '../Footer/newFooter'
import { MyFormLabel } from '../../utils/clientUtilities'
import Select from "react-select";
import { CitySearch, clientAnalytics, clientError, StateSvg } from '../../utils/utilties'
import emptyState from "../../public/images/search/emptyState.svg";
import { IoIosArrowDown } from 'react-icons/io'
import { TriggerFiltersWrapper, TriggerFiltersButton } from '../BigSearcher/StyledBigSearcher'
import BigSearcher from '../BigSearcher/BigSearcher'
import { getToken } from '../../src/config/firebase'
import { useAuth } from '../../utils/auth/newAuth'
import SideNav from '../SideNav/SideNav'


const libraries = ["places"];
interface recipient {
  uid: string;
  fullName: string;
  photoURL: string;
  title: string;
  pro: boolean;
}
interface reactSelectType {
  label?: string,
  value?: string
}

interface queryStateType {
  page?: number;
  location?: string;
  expertise?: string;
  brokerage?: string;
}
const FindAnAgent = ({ staticData }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_MAPS_API_KEY,
    // @ts-ignore
    libraries,
  });

  const { userId } = useAuth();
  const [pageData, setPageData] = useState(staticData)
  const {
    agents, proAgents, pages
  } = pageData;
  const toast = useToast();
  const router = useRouter();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [queryState, setQueryState] = useState<queryStateType>({});
  const [staticStatus, setStaticStatus] = useState(!!staticData);
  const [cityData, setCityData] = useState<reactSelectType>();
  const [expertise, setExpertise] = useState<reactSelectType>();
  const [brokerageFinderText, setBrokerageFinderText] = useState(null);
  const [messageStatus, setMessageStatus] = useState('idle')
  // const [foundBrokerages, setFoundBrokerages] = useState([]);
  const [brokerage, setBrokerage] = useState<reactSelectType>()
  const [messageText, setMessageText] = useState('')
  const [messageToSend, setMessageToSend] = useState(false);
  const [currentRecipient, setCurrentRecipient] = useState<recipient>({
    uid: null,
    fullName: null,
    photoURL: null,
    title: null,
    pro: null
  });
  const [sentMessages, setSentMessages] = useState([])

  useEffect(() => {
    // Don't update if cityData is null query state's city is also null
    if (cityData || queryState?.location !== undefined) {
      updateAgentFilters({
        ...queryState,
        page: null,
        location: cityData?.value ?? null,
      });
    }
  }, [cityData]);

  useEffect(() => {
    // If the page has been loaded and query state is empty, use the router queries to query
    if (router.query && Object.keys(router.query).length > 0 && Object.keys(queryState).length === 0) {
      updateAgentFilters({
        ...router.query
      })
      const { expertise: exp, location, brokerage: bk }: queryStateType = router.query;
      expertise ? setExpertise({ label: exp, value: exp }) : null;
      location ? setCityData({ label: location, value: location }) : null;
      bk && setBrokerage({ label: bk, value: bk });

    }
  }, [router.query])
  const updateAgentFilters = (updatedQueryState: typeof queryState) => {

    // Setting page to null first for scenarios where page is not included in the query but was previously there - if someone updates the query after being on page 2, we want page to be reset. If the query does include info on the page number then it will stay due to the spread operator superseding it 
    setQueryState({ page: null, ...updatedQueryState });

    // Remove any nulls
    Object.keys(updatedQueryState).forEach(i => {
      if (!updatedQueryState[i]) {
        delete updatedQueryState[i]
      }
    })
    router.replace(
      {
        pathname: router.pathname,
        query: { ...updatedQueryState },
      },
      undefined,
      { shallow: true }
    );
  };

  const handleMessageSubmit = () => {
    messageMutation.mutate({
      message: messageText,
      uid: userId,
      recipient: currentRecipient.uid
    })
  }



  async function fetchAgentsRequest() {

    // if (staticStatus) {
    //     const { coordinates } = staticData;

    //     setLocalCoordinates(coordinates);
    //     setRefreshCoordinates(true);
    //     return staticData;
    // } else {
    const response = await fetch(
      `/api/agents`,
      {
        method: "GET",
        headers: {
          queries: JSON.stringify(queryState),
        },
      }
    );
    const data = await response.json();
    // Set refresh coordinates back to true
    return data;
    // }
  }
  function clearFilters() {
    setExpertise(null);
    setCityData(null);
    setBrokerage(null);
    updateAgentFilters({})
  }

  const { data, status, error, refetch } = useQuery(
    ["agents", queryState, staticData],
    fetchAgentsRequest,
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setPageData(data);
      },
    }
  );

  async function findBrokerageRequest() {
    const response = await fetch(
      `/api/brokerages?phrase=${brokerageFinderText}`,
      {
        method: "GET",
      }
    );
    const receivedData = await response.json();
    const { brokerageOptions } = receivedData;
    return brokerageOptions;
  }

  const { data: foundBrokerages, error: userError, status: brokerageStatus } = useQuery(
    ["brokerageFinder", brokerageFinderText],
    findBrokerageRequest,
    {
      refetchOnWindowFocus: false,
      enabled: !!brokerageFinderText,
      onSuccess: (data) => {
        if (!data) {
          throw "error";
          // setStatus("error");
        } 
      },
      onError: (error) => {
        clientError(error);
      },
    }
  );

  async function createMessageRequest(messageData) {
    messageStatus == "loading" ? null : setMessageStatus("loading");
    const response = await fetch("/api/messages/create?scenario=O1", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
      },
      body: JSON.stringify({ message: messageData }),
    });

    const data = await response.json();
    return data;
  }

  const messageMutation = useMutation(createMessageRequest, {
    onError: (error) => {
      // An error happened!
      clientError(error);
      setMessageStatus("error");
      toast({
        position: "bottom",
        title: "Message failed",
        description: `Your message failed to send to ${currentRecipient.fullName}. We're looking into this now and will get back to you as soon as we can.`,
        status: "error",
        duration: 5000,
      });
    },

    onSuccess: async (data, variables, context) => {
      if (data.theMessage) {
        const { theMessage } = data;
        const { convoId, senderEmail, senderPhone } = theMessage;
        setMessageStatus("success");
        setMessageToSend(false);
        toast({
          status: "success",
          title: "Message sent",
          variant: 'subtle',
          description: `Your message to ${currentRecipient.fullName} was successfully sent`
        })
        setSentMessages([...sentMessages, currentRecipient.uid])
        clientAnalytics.track("DM to agent (client)", {
          route: 'Agents page'
        });

      }

      else if (data.specificError) {
        setMessageStatus('idle');
        setMessageToSend(false);
        toast({
          title: data.specificError,
          status: "warning",
          variant: "subtle",
          duration: 5000,
          isClosable: true,
        });
      }
      else {
        throw "An error occured trying to send DM";
      }
      isOpen && onClose();
    },
  });


  return (<>
    <SideNav />
    <MainContainer>
      <PentagonBg image={pentagon}>
        <Container>
          <Box>
            <HeaderText>Find the Right Commercial Agent for You</HeaderText>
          </Box>
          <Box
            h="100px"
          >
            <BigSearcher peopleOnly={true} />
            {/* <HoriLine /> */}
            <Flex
              marginTop="20px"
              gridColumnGap={"32px"}
              flexWrap="wrap"
            >
              <Box marginBottom="20px" minWidth="250px" flexGrow={1} maxWidth="400px">
                <MyFormLabel htmlFor="area">Expertise</MyFormLabel>
                <Select
                  value={expertise}
                  name="area"
                  clearable={true}
                  searchable
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#125F3F",
                      primary25: "#b1cab3",
                      primary50: "#b1cab3",
                    },
                  })}
                  options={[
                    { label: "All types", value: "all" },
                    ...propertyTypeOptions]}
                  onChange={(s) => {
                    setExpertise(s)
                    updateAgentFilters({
                      ...queryState,
                      page: null,
                      expertise: s.value === 'all' ? null : s.value
                    });
                  }}
                // onInputChange={(e) => {
                //   e.length > 0 ? handleInput(e) : null;
                // }}
                />
              </Box>


              <Box minWidth="250px" flexGrow={1} maxWidth="400px">
                {isLoaded && (
                  <CitySearch cityData={cityData} setCityData={setCityData} />
                )}
              </Box>

              <Box marginBottom="20px" minWidth="290px" flexGrow={1} >

                <Flex
                  alignItems={'center'}
                  justifyContent="space-between"
                >
                  <MyFormLabel htmlFor="brokerage">Brokerage</MyFormLabel>
                  {!!brokerage &&
                    <Button
                      size="sm"
                      leftIcon={<SmallCloseIcon />}
                      variant={'link'}
                      colorScheme='green'
                      onClick={() => {
                        setBrokerage(null);
                        updateAgentFilters({
                          ...queryState,
                          page: null,
                          brokerage: null
                        })
                      }}
                    >
                      Clear
                    </Button>
                  }
                </Flex>

                <Select
                  value={brokerage}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#125F3F",
                      primary25: "#b1cab3",
                      primary50: "#b1cab3",
                    },
                  })}
                  filterOption={(options, filter, current_values) => { return options; }}
                  name="brokerage"
                  options={foundBrokerages}
                  onInputChange={(e) => {
                    e.length > 0 ? setBrokerageFinderText(e) : null;
                  }}
                  noOptionsMessage={() =>
                    brokerageStatus == 'loading'
                      ? "Loading"
                      : brokerageFinderText?.length < 1
                      ? "Begin typing"
                      : "No options"
                  }
                  onChange={(i) => {

                    setBrokerage(i)
                    updateAgentFilters({
                      ...queryState,
                      page: null,
                      brokerage: i.value
                    })
                  }}
                />
              </Box>
            </Flex>
          </Box>
        </Container>
      </PentagonBg>
      <ContentContainer>
        
        <Container>
        {
              Object.keys(queryState).filter(i => i !== 'page' && queryState[i]).length > 0 &&
              <Box>

                <Button
                  mr="8px"
                  onClick={clearFilters}
                  color="rgb(109, 121, 139)"
                  fontWeight="400"
                  _active={{ background: "myGray.300" }}
                  _hover={{ background: "myGray.50" }}
                  leftIcon={<SmallCloseIcon />}
                  variant="solid"
                  mb="30px"
                >
                  Clear all filters
                </Button>

              </Box>
            }

          {status === "loading" && (
            <ListingsSpinnerHolder>
              <Spinner size="xl" color="green.800" />
            </ListingsSpinnerHolder>
          )}


          {status !== 'loading' &&
            <>

              {proAgents?.length > 0 &&
                <>
                  <SectionHeader bold={true}
                  >
                    Top agents
                  </SectionHeader>
                  <AgentCardHolder>
                    {proAgents?.map(i => (
                      <AgentCard
                        messageSent={sentMessages.includes(i.uid)}
                        setMessageToSend={setMessageToSend}
                        setCurrentRecipient={setCurrentRecipient}
                        onOpen={onOpen}
                        key={i.uid}
                        {...i}

                      />
                    ))}
                  </AgentCardHolder>

                  <Box h="60px" />
                </>

              }

              <SectionHeader
              >
                All agents
              </SectionHeader>
              {status === "success" &&
                ((!agents ||
                  agents?.length === 0) && (!proAgents || proAgents?.length === 0)) && (
                  <StateSvg
                    svg="/images/search/emptyState.svg"
                    heading="No matching results"
                    subHeading="Looks like nothing matches that criteria. Try changing filters to see different results."
                  />
                )}
              <AgentCardHolder>
                {agents?.map((i, index) => (
                  <AgentCard
                  messageSent={sentMessages.includes(i.uid)}
                  setMessageToSend={setMessageToSend}
                  setCurrentRecipient={setCurrentRecipient}
                  onOpen={onOpen}
                  key={i.uid}
                  {...i}
                  />
                ))}
              </AgentCardHolder>

              {pages > 1 && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "40px 0 20px",
                    }}
                  >
                    {data?.currentPage > 1 && (
                      <Link
                        prefetch={false}
                        href={{
                          pathname: router.pathname,
                          query: {
                            ...queryState,
                            page: data.currentPage - 1,
                          },
                        }}>

                        <Button
                          _focus={{
                            boxShadow: "none",
                          }}
                          mr="10px"
                          onClick={() => {
                            updateAgentFilters({
                              ...queryState,
                              page: data.currentPage - 1,
                            });
                            // setFieldValue(
                            //   "page",
                            //   data.currentPage - 1
                            // );
                          }}
                          colorScheme="green"
                          variant="outline"
                          leftIcon={<ChevronLeftIcon />}
                        >
                          Previous
                        </Button>

                      </Link>
                    )}

                    {data?.pages > data?.currentPage && (
                      <Link
                        href={{
                          pathname: router.pathname,
                          query: {
                            ...queryState,
                            page: data.currentPage + 1,
                          },
                        }}
                        prefetch={false}>

                        <Button
                          _focus={{
                            boxShadow: "none",
                          }}
                          onClick={() => {
                            updateAgentFilters({
                              ...queryState,
                              page: data.currentPage + 1,
                            });
                            // setFieldValue(
                            //   "page",
                            //   data.currentPage + 1
                            // );
                          }}
                          colorScheme="green"
                          variant="outline"
                          rightIcon={<ChevronRightIcon />}
                        >
                          Next
                        </Button>

                      </Link>
                    )}
                  </div>

                  <PaginationButtonHolder>
                    {[...Array(pages)].map((value, index) => {
                      const agentsPageNumber = index + 1;
                      return (
                        (<Link
                          key={index}
                          href={{
                            pathname: "/agents",
                            query: {
                              ...queryState,
                              page: agentsPageNumber,
                            },
                          }}
                          prefetch={false}>

                          <Button
                            onClick={() => {
                              agentsPageNumber !==
                                pageData?.currentPage
                                ? updateAgentFilters({
                                  ...queryState,
                                  page: agentsPageNumber,
                                })
                                : // setFieldValue("page", agentsPageNumber) :
                                null;
                            }}
                            colorScheme="green"
                            variant={
                              pageData?.currentPage ===
                                agentsPageNumber
                                ? "solid"
                                : "ghost"
                            }
                            borderRadius="50%"
                            width="2rem"
                            height="2rem"
                            mb="5px"
                            mr="5px"
                            size="sm"
                          >
                            {agentsPageNumber}
                          </Button>

                        </Link>)
                      );
                    })}
                  </PaginationButtonHolder>
                </>
              )}
            </>
          }


        </Container>


      </ContentContainer>
      <NewFooter faq={false} isProfessional={false} />

      {/* Messaging modal */}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Message {currentRecipient.fullName}</ModalHeader>

          <ModalCloseButton

          />
          <ModalBody>
              <Flex justifyContent="flex-start" marginBottom="25px" >
                <Avatar src={currentRecipient.photoURL ? currentRecipient.photoURL : ""} size="md" mr="10px" />

                <Flex flexDirection="column" justifyContent="center">
                  <Flex alignItems="center">
                    <Text
                      fontSize="1.3rem"
                      fontWeight="500">{currentRecipient.fullName}</Text>

                    {currentRecipient.pro && (
                      <Badge ml="6px" variant="solid" colorScheme="green">
                        Pro
                      </Badge>
                    )}
                  </Flex>
                  <Text>{currentRecipient.title}</Text>
                </Flex>
              </Flex>
            <Textarea
              autoFocus
              value={messageText}
              placeholder="Your message here"
              onChange={(e) => setMessageText(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            {(messageText.length > 300 || (messageText.length < 5 && messageText.length > 0)) &&
              <Text
                color="tomato"
                mr="12px"
                fontSize="14px"
              >
                {messageText.length < 5 ? "Please type a longer message" : messageText.length > 300 ? "Message too long" : null}
              </Text>
            }
            <ButtonGroup size="sm">
              <Button
                tabIndex={2}
                colorScheme="green"
                onClick={handleMessageSubmit}
                type="button"
                isDisabled={messageStatus === 'loading' || messageText.length < 5 || messageText.length > 300}
                isLoading={messageStatus == "loading"}
                loadingText="Updating..."
              >
                Send
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </MainContainer>
  </>);
}

export default FindAnAgent
